import carpoolBg from "../../assets/carpool_bg.png";

// ... (other imports remain, this is conceptually where I will insert the import. I need to be careful with `replace_file_content` targeting).

// Actually, I should use `multi_replace_file_content` to add import and update style.

import { COLORS } from "../../assets/colors";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import api from "../../services/api";
import Ride from "../RideV2";
import NoData from "../NoData";
import SearchField from "./Search";
import { Pagination } from "@material-ui/lab";
import { toast } from "react-toastify";
import mixins from "../../mixins";
import Filters from "../Filters";
import { Chip } from "@material-ui/core";
import { ClearAll, FilterListOutlined } from "@material-ui/icons";
import FilterModal from "../../components/models/FilterModal";
import { FaCar, FaPlus, FaSearch } from "react-icons/fa";
import CircularLoader from "../UI/Loader";
import { Helmet } from "react-helmet";
import styled from "styled-components";

const SilkPort = ({ openSearchModal }) => {
  const [currentCities, setCurrentCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [rides, setRides] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [pages, setPages] = useState(1);
  const [pageSize, setPageSize] = useState(6);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState(null);
  const [departureTime, setDepartureTime] = useState(null);
  const [amenity, setAmenity] = useState(null);
  const [showFilters, setShowFilters] = useState(false);

  const offset = (page - 1) * pageSize;

  const navigate = useNavigate();

  useEffect(() => {
    async function getDepartureCities() {
      setLoading(true);
      const response = await api.get("ride/leavingFrom");
      setCurrentCities(response.data.data);
      setLoading(false);
    }
    getDepartureCities();
  }, []);

  useEffect(() => {
    async function getRidesLeavingFrom() {
      setLoading(true);

      let params = {
        limit: limit,
        offset: offset,
      };
      if (sortBy) {
        params = { ...params, sortBy };
      }
      if (departureTime) {
        params = { ...params, departureTime };
      }
      if (amenity) {
        params = { ...params, amenity };
      }

      if (!selectedCity) {
        const response = await api.get(`ride/`, {
          params,
        });
        setRides(response.data.data);
        if (response.data.totalRides > 0) {
          setPages(Math.ceil(response.data.totalRides / pageSize));
        }
      } else {
        const response = await api.get(`ride/getRides/${selectedCity}`, {
          params,
        });
        setRides(response.data.data);
        if (response.data.totalRides > 0) {
          setPages(Math.ceil(response.data.totalRides / pageSize));
        }
      }
      setLoading(false);
    }
    getRidesLeavingFrom();
  }, [selectedCity, offset, sortBy, departureTime, amenity]);

  const handleCity = (city) => {
    if (!selectedCity) {
      setPage(1);
    }
    setSelectedCity(city);
  };

  const searchCity = async (event) => {
    const searchText = event.target.value;
    if (searchText === "") {
      setSearchTerm(searchText);
      setLoading(true);
      const response = await api.get("ride/leavingFrom");
      setCurrentCities(response.data.data);
      setLoading(false);
    } else {
      setSearchTerm(searchText);
      const filteredResults = currentCities.filter((item) =>
        item.leaving_from.toLowerCase().includes(searchText.toLowerCase())
      );
      setCurrentCities(filteredResults);
    }
  };
  const handleChange = (event, value) => {
    setPage(value);
  };
  const showAllRides = async () => {
    try {
      setLoading(true);
      setSelectedCity("");
      const params = {
        limit: limit,
        offset: offset,
      };
      const response = await api.get(`ride/`, {
        params,
      });
      setRides(response.data.data);
      if (response.data.totalRides > 0) {
        setPages(Math.ceil(response.data.totalRides / pageSize));
      }
      setLoading(false);
    } catch (e) {
      toast.error("Something went wrong");
    }
  };
  const clearSearch = async () => {
    setSearchTerm("");
    setSelectedCity("");
    const response = await api.get("ride/leavingFrom");
    setCurrentCities(response.data.data);
  };
  const handleSort = (sorter) => {
    if (sorter == sortBy) {
      setSortBy(null);
    } else {
      setSortBy(sorter);
    }
  };
  const handleDeparturetime = (dptime) => {
    if (departureTime == dptime) {
      setDepartureTime(null);
    } else {
      setDepartureTime(dptime);
    }
  };
  const handleAmenity = (_amenty) => {
    if (amenity == _amenty) {
      setAmenity(null);
    } else {
      setAmenity(_amenty);
    }
  };
  const clearAll = () => {
    setSortBy(null);
    setDepartureTime(null);
    setAmenity(null);
  };

  return (
    <StyledSilkPort>
      <Helmet>
        <title>{`Carpool Rides from ${selectedCity} - GoSawari`}</title>

        {/* Dynamic meta description with a focus on the city */}
        <meta
          name="description"
          content={`Find and book inclusive carpool rides for men and women leaving from ${selectedCity} with GoSawari. Share your ride and reduce travel costs safely.`}
        />

        {/* Canonical link for the specific selectedCity */}
        <link rel="canonical" href={`https://gosawari.com/carpool`} />
      </Helmet>
      <div className="sider">
        <div className="sider__header">
          <SearchField
            onChange={searchCity}
            clearSearch={clearSearch}
            value={searchTerm}
            placeholder="Search departure..."
          />
        </div>
        <div className="sider__content">
          <ul>
            {currentCities?.length == 0 ? (
              <p style={{ color: "gainsboro", padding: "1rem" }}>No data</p>
            ) : (
              <>
                <li className={"departure"}>Departure</li>
                <li
                  className={selectedCity == "" ? "active" : null}
                  onClick={showAllRides}
                >
                  Latest rides
                </li>
              </>
            )}

            {currentCities?.length > 0 &&
              currentCities.map((city, index) => (
                <li
                  key={index}
                  className={
                    selectedCity === city.leaving_from ? "active" : null
                  }
                  onClick={() => handleCity(city.leaving_from)}
                >
                  {city.leaving_from}
                </li>
              ))}
          </ul>
          <div className="bottom"></div>
        </div>
      </div>
      <div className="content">
        <div className="content__header">
          <div className="content__header--left">
            <h2>
              {selectedCity
                ? `${selectedCity} to other locations`
                : "Latest rides"}
            </h2>
            {selectedCity ? (
              <p>
                Available rides from <strong>{selectedCity}</strong> to the
                other locations in Pakistan
              </p>
            ) : (
              <p>Find the rides leaving from your city</p>
            )}
          </div>
          <div className="content__header--right">
            {selectedCity && (
              <Button onClick={showAllRides}>
                <CarIcon />
                Show All
              </Button>
            )}
            {(sortBy || amenity || departureTime) && (
              <Button
                onClick={() => {
                  setSortBy(null);
                  setAmenity(null);
                  setDepartureTime(null);
                }}
              >
                <ClearAll />
                Clear filters
              </Button>
            )}

            <Button onClick={() => openSearchModal()}>
              <SearchIcon />
              Search Ride
            </Button>
            <Button onClick={() => navigate("/publish")}>
              <CreateIcon />
              Create Ride
            </Button>
            {window.innerWidth <= 1368 && (
              <Button onClick={() => setShowFilters(true)}>
                <FilterListOutlined />
                Filters
              </Button>
            )}
          </div>
        </div>
        <div>
          {(sortBy || amenity || departureTime) && (
            <FiltersSelected>
              {sortBy && (
                <Chip
                  label={
                    sortBy == "earliest"
                      ? "Earliest departure"
                      : sortBy == "price"
                      ? "Lowest price"
                      : sortBy
                  }
                  variant="outlined"
                  onDelete={() => {
                    setSortBy(null);
                  }}
                />
              )}
              {amenity && (
                <Chip
                  label={
                    amenity == "2inB"
                      ? "Max 2 in back"
                      : amenity == "smoking"
                      ? "smoking allowed"
                      : amenity
                  }
                  variant="outlined"
                  onDelete={() => {
                    setAmenity(null);
                  }}
                />
              )}

              {departureTime && (
                <Chip
                  label={
                    departureTime === "bf6"
                      ? "Before 06:00 AM"
                      : departureTime === "after6Pm"
                      ? "After 18:00"
                      : departureTime === "6-12"
                      ? "6AM - 12PM"
                      : departureTime == "12-18"
                      ? "12:00 - 18:00"
                      : departureTime
                  }
                  variant="outlined"
                  onDelete={() => {
                    setDepartureTime(null);
                  }}
                />
              )}
            </FiltersSelected>
          )}
        </div>
        <div className="content__body">
          {isLoading && (
            <div style={{ width: "100%" }}>
              <CircularLoader isLoading={isLoading} />
            </div>
          )}
          <div className="cardContainer">
            {rides?.length == 0 && !isLoading && (
              <div className="no-data">
                <NoData
                  showImage={false}
                  title={"Currently, no rides are available."}
                  message={
                    "Explore available rides by selecting a city to view all departing options or search for a specific ride."
                  }
                />
              </div>
            )}
            {rides?.length > 0 &&
              !isLoading &&
              rides.map((item) => {
                return (
                  <div className="card">
                    <Ride ride={item} isMine={false} />
                  </div>
                );
              })}
          </div>
          {rides?.length > 0 && (
            <div className="filters">
              <Filters
                handleSort={handleSort}
                sortBy={sortBy}
                handleDeparturetime={handleDeparturetime}
                departureTime={departureTime}
                handleAmenity={handleAmenity}
                amenity={amenity}
                clearAll={clearAll}
                page={"carpool"}
              />
            </div>
          )}
        </div>
        {!isLoading && pages > 1 && (
          <div className="pagination">
            <Pagination
              onChange={handleChange}
              size="large"
              page={page}
              count={pages}
              color="primary"
            />
          </div>
        )}
        {showFilters && (
          <FilterModal
            isOpen={showFilters}
            setIsOpen={setShowFilters}
            handleSort={handleSort}
            sortBy={sortBy}
            handleDeparturetime={handleDeparturetime}
            departureTime={departureTime}
            handleAmenity={handleAmenity}
            amenity={amenity}
            clearAll={clearAll}
          />
        )}
      </div>
    </StyledSilkPort>
  );
};

export default SilkPort;
const FiltersSelected = styled.div`
  display: flex;
  margin: 1rem;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

const StyledSilkPort = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  background: url(${carpoolBg}) no-repeat center center fixed;
  background-size: cover;
  overflow: hidden;

  @media (max-width: 900px) {
    flex-direction: column;
    overflow: auto;
  }

  .sider {
    background: var(--sider-bg);
    backdrop-filter: blur(var(--glass-blur));
    box-shadow: 2px 0 10px rgba(0,0,0,0.02);
    border-right: 1px solid rgba(255, 255, 255, 0.3);
    color: #37474f;
    flex: 0 0 18rem;
    min-width: 18rem;
    display: flex;
    flex-direction: column;
    
    &__header {
      padding: 1.5rem;
      border-bottom: 1px solid #f1f5f9;
      
      h2 {
        margin-bottom: 0.5rem;
        font-size: 1.1rem;
        font-weight: 700;
        color: #054752;
      }
      p {
        color: #94a3b8;
        font-size: 0.85rem;
      }
    }

    &__content {
      flex: 1;
      overflow-y: auto;
      padding: 1rem 0;
      ${mixins.scrollStyleSilkPort};

      ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
          padding: 0.75rem 1.5rem;
          cursor: pointer;
          font-size: 0.95rem;
          color: #64748b;
          transition: all 0.2s ease;
          border-left: 3px solid transparent;

          &:hover {
            background: #f0fdfa;
            color: #054752;
          }

          &.active {
            background: #e0f2f1;
            color: #00695c;
            border-left-color: #00695c;
            font-weight: 600;
          }

          &.departure {
             cursor: default;
             font-size: 0.75rem;
             text-transform: uppercase;
             letter-spacing: 0.05em;
             color: #94a3b8;
             padding-top: 1rem;
             padding-bottom: 0.5rem;
             font-weight: 600;
             &:hover {
               background: transparent;
             }
          }
        }
        
        @media (max-width: 900px) {
          display: flex;
          overflow-x: auto;
          white-space: nowrap;
          padding-bottom: 1rem;
          
          li {
            border-left: none;
            border-bottom: 2px solid transparent;
            padding: 0.5rem 1rem;
            
            &.active {
              background: transparent;
              border-bottom-color: #00695c;
            }
          }
        }
      }
    }
  }

  .content {
    flex: 1;
    padding: 2rem;
    overflow-y: auto;
    background: #f8fafc;
    
    @media (max-width: 546px) {
      padding: 1rem;
      padding-bottom: 6rem;
    }

    &__header {
      margin-bottom: 2rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 1.5rem;
      
      &--left {
        h2 {
          font-size: 2rem;
          color: #1e293b;
          font-weight: 700;
          margin-bottom: 0.5rem;
        }
        p {
          color: #64748b;
          font-size: 1rem;
        }
      }

      &--right {
        display: flex;
        gap: 1rem;
        flex-wrap: wrap;
      }
      
      @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
      }
    }

    &__body {
      .cardContainer {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
        gap: 1.5rem;
        margin-bottom: 2rem;
        
        .no-data {
           grid-column: 1 / -1;
        }
      }

      .filters {
        position: fixed;
        right: 1rem;
        top: 25%;
        z-index: 100;
        background: white;
        padding: 1rem;
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0,0,0,0.1);
        width: 14rem;
        
        @media (max-width: 1450px) {
          display: none;
        }
      }
    }

    .pagination {
      display: flex;
      justify-content: center;
      margin-top: 3rem;
    }
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #054752;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 6px rgba(5, 71, 82, 0.2);

  &:hover {
    background-color: #006064;
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(5, 71, 82, 0.3);
  }

  &:active {
    transform: translateY(0);
  }
`;

const SearchIcon = styled(FaSearch)`
  margin-right: 0.5rem;
`;

const CreateIcon = styled(FaPlus)`
  margin-right: 0.5rem;
`;
const CarIcon = styled(FaCar)`
  margin-right: 0.5rem;
`;
